import * as React from "react";

interface IProps {
    jsScripts?: JSX.Element[];
}

interface IState {
    scripts?: any[]
}

export class Footer extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            scripts: []
        }
    }

    public componentDidMount = () => {
        this.setState({
            scripts: this.props.jsScripts
        });
    }

    public render() {
        return (
            <div className="footer-section">
                <section className="small-section bg-dark">
                    <div className="container relative">
                        <div className="align-center">
                            <h3 className="banner-heading font-alt">Ada saran atau Kritik tentang website kami?</h3>
                            <div><a className="btn btn-mod btn-w btn-medium btn-round" href="mp-index-15.html">Hubungi Kami</a>
                            </div>
                        </div>
                    </div>
                </section>
                <footer className="page-section bg-gray-lighter footer pb-60">
                    <div className="container">
                        <div className="footer-social-link mb-xs-60" />
                        <div className="footer-text">
                            <div className="footer-copy font-alt">
                                <span>© Desa Sanur Kauh 2019</span>.
                                </div>
                            <div className="footer-made">Tjakra Project.</div>
                        </div>
                    </div>
                    <div className="local-scroll" />
                </footer>
                {this.state.scripts}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/layout/Footer.tsx